var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14598 4.64601C2.19242 4.59945 2.2476 4.5625 2.30834 4.5373C2.36909 4.51209 2.43421 4.49911 2.49998 4.49911C2.56575 4.49911 2.63087 4.51209 2.69161 4.5373C2.75236 4.5625 2.80753 4.59945 2.85398 4.64601L5.99998 7.79301L9.14598 4.64601C9.23986 4.55212 9.3672 4.49938 9.49998 4.49938C9.63275 4.49938 9.76009 4.55212 9.85398 4.64601C9.94787 4.7399 10.0006 4.86723 10.0006 5.00001C10.0006 5.13278 9.94787 5.26012 9.85398 5.35401L6.35398 8.85401C6.30753 8.90057 6.25236 8.93751 6.19161 8.96272C6.13087 8.98793 6.06575 9.0009 5.99998 9.0009C5.93421 9.0009 5.86909 8.98793 5.80834 8.96272C5.7476 8.93751 5.69242 8.90057 5.64598 8.85401L2.14598 5.35401C2.09941 5.30756 2.06247 5.25239 2.03727 5.19164C2.01206 5.1309 1.99908 5.06578 1.99908 5.00001C1.99908 4.93424 2.01206 4.86912 2.03727 4.80837C2.06247 4.74763 2.09941 4.69245 2.14598 4.64601Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDownArrow);
export default __webpack_public_path__ + "static/media/white-down-arrow.d8e6c017d8cf4d3cf883883e28fe0e36.svg";
export { ForwardRef as ReactComponent };